export const LABELS = {
    WITH_PROMO_CODE: 'with promo code',
    IF_ORDER_NOW: 'If Ordered Now!',
    RETURN_BACK: "Return Back"
}

export const MESSAGES = {
    NO_PRODUCTS_AVAILABLE: "There are no products available for this product group"
}
